import './Stencil.css.proxy.js';
/* src/components/Stencil.svelte generated by Svelte v3.55.0 */
import {
	SvelteComponentDev,
	add_location,
	append_hydration_dev,
	attr_dev,
	children,
	claim_element,
	claim_space,
	claim_text,
	detach_dev,
	dispatch_dev,
	element,
	init,
	insert_hydration_dev,
	noop,
	safe_not_equal,
	set_data_dev,
	space,
	src_url_equal,
	text as text_1,
	validate_slots
} from "../../web_modules/svelte/internal.js";

const file = "src/components/Stencil.svelte";

function create_fragment(ctx) {
	let div1;
	let img;
	let img_src_value;
	let t0;
	let div0;
	let t1;

	const block = {
		c: function create() {
			div1 = element("div");
			img = element("img");
			t0 = space();
			div0 = element("div");
			t1 = text_1(/*text*/ ctx[0]);
			this.h();
		},
		l: function claim(nodes) {
			div1 = claim_element(nodes, "DIV", { id: true });
			var div1_nodes = children(div1);

			img = claim_element(div1_nodes, "IMG", {
				class: true,
				src: true,
				alt: true,
				style: true
			});

			t0 = claim_space(div1_nodes);
			div0 = claim_element(div1_nodes, "DIV", { class: true });
			var div0_nodes = children(div0);
			t1 = claim_text(div0_nodes, /*text*/ ctx[0]);
			div0_nodes.forEach(detach_dev);
			div1_nodes.forEach(detach_dev);
			this.h();
		},
		h: function hydrate() {
			attr_dev(img, "class", "stencil  svelte-m8ypxz");
			if (!src_url_equal(img.src, img_src_value = /*image*/ ctx[2])) attr_dev(img, "src", img_src_value);
			attr_dev(img, "alt", /*helpText*/ ctx[1]);
			attr_dev(img, "style", /*style*/ ctx[4]);
			add_location(img, file, 9, 0, 138);
			attr_dev(div0, "class", "slds-text-heading_large slds-align_absolute-center");
			add_location(div0, file, 10, 0, 203);
			attr_dev(div1, "id", /*id*/ ctx[3]);
			add_location(div1, file, 8, 0, 124);
		},
		m: function mount(target, anchor) {
			insert_hydration_dev(target, div1, anchor);
			append_hydration_dev(div1, img);
			append_hydration_dev(div1, t0);
			append_hydration_dev(div1, div0);
			append_hydration_dev(div0, t1);
		},
		p: function update(ctx, [dirty]) {
			if (dirty & /*image*/ 4 && !src_url_equal(img.src, img_src_value = /*image*/ ctx[2])) {
				attr_dev(img, "src", img_src_value);
			}

			if (dirty & /*helpText*/ 2) {
				attr_dev(img, "alt", /*helpText*/ ctx[1]);
			}

			if (dirty & /*style*/ 16) {
				attr_dev(img, "style", /*style*/ ctx[4]);
			}

			if (dirty & /*text*/ 1) set_data_dev(t1, /*text*/ ctx[0]);

			if (dirty & /*id*/ 8) {
				attr_dev(div1, "id", /*id*/ ctx[3]);
			}
		},
		i: noop,
		o: noop,
		d: function destroy(detaching) {
			if (detaching) detach_dev(div1);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_fragment.name,
		type: "component",
		source: "",
		ctx
	});

	return block;
}

function instance($$self, $$props, $$invalidate) {
	let { $$slots: slots = {}, $$scope } = $$props;
	validate_slots('Stencil', slots, []);
	let { text } = $$props;
	let { helpText } = $$props;
	let { image } = $$props;
	let { id } = $$props;
	let { style } = $$props;

	$$self.$$.on_mount.push(function () {
		if (text === undefined && !('text' in $$props || $$self.$$.bound[$$self.$$.props['text']])) {
			console.warn("<Stencil> was created without expected prop 'text'");
		}

		if (helpText === undefined && !('helpText' in $$props || $$self.$$.bound[$$self.$$.props['helpText']])) {
			console.warn("<Stencil> was created without expected prop 'helpText'");
		}

		if (image === undefined && !('image' in $$props || $$self.$$.bound[$$self.$$.props['image']])) {
			console.warn("<Stencil> was created without expected prop 'image'");
		}

		if (id === undefined && !('id' in $$props || $$self.$$.bound[$$self.$$.props['id']])) {
			console.warn("<Stencil> was created without expected prop 'id'");
		}

		if (style === undefined && !('style' in $$props || $$self.$$.bound[$$self.$$.props['style']])) {
			console.warn("<Stencil> was created without expected prop 'style'");
		}
	});

	const writable_props = ['text', 'helpText', 'image', 'id', 'style'];

	Object.keys($$props).forEach(key => {
		if (!~writable_props.indexOf(key) && key.slice(0, 2) !== '$$' && key !== 'slot') console.warn(`<Stencil> was created with unknown prop '${key}'`);
	});

	$$self.$$set = $$props => {
		if ('text' in $$props) $$invalidate(0, text = $$props.text);
		if ('helpText' in $$props) $$invalidate(1, helpText = $$props.helpText);
		if ('image' in $$props) $$invalidate(2, image = $$props.image);
		if ('id' in $$props) $$invalidate(3, id = $$props.id);
		if ('style' in $$props) $$invalidate(4, style = $$props.style);
	};

	$$self.$capture_state = () => ({ text, helpText, image, id, style });

	$$self.$inject_state = $$props => {
		if ('text' in $$props) $$invalidate(0, text = $$props.text);
		if ('helpText' in $$props) $$invalidate(1, helpText = $$props.helpText);
		if ('image' in $$props) $$invalidate(2, image = $$props.image);
		if ('id' in $$props) $$invalidate(3, id = $$props.id);
		if ('style' in $$props) $$invalidate(4, style = $$props.style);
	};

	if ($$props && "$$inject" in $$props) {
		$$self.$inject_state($$props.$$inject);
	}

	return [text, helpText, image, id, style];
}

class Stencil extends SvelteComponentDev {
	constructor(options) {
		super(options);

		init(this, options, instance, create_fragment, safe_not_equal, {
			text: 0,
			helpText: 1,
			image: 2,
			id: 3,
			style: 4
		});

		dispatch_dev("SvelteRegisterComponent", {
			component: this,
			tagName: "Stencil",
			options,
			id: create_fragment.name
		});
	}

	get text() {
		throw new Error("<Stencil>: Props cannot be read directly from the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	set text(value) {
		throw new Error("<Stencil>: Props cannot be set directly on the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	get helpText() {
		throw new Error("<Stencil>: Props cannot be read directly from the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	set helpText(value) {
		throw new Error("<Stencil>: Props cannot be set directly on the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	get image() {
		throw new Error("<Stencil>: Props cannot be read directly from the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	set image(value) {
		throw new Error("<Stencil>: Props cannot be set directly on the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	get id() {
		throw new Error("<Stencil>: Props cannot be read directly from the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	set id(value) {
		throw new Error("<Stencil>: Props cannot be set directly on the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	get style() {
		throw new Error("<Stencil>: Props cannot be read directly from the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	set style(value) {
		throw new Error("<Stencil>: Props cannot be set directly on the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}
}

export default Stencil;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiU3RlbmNpbC5zdmVsdGUiXSwic291cmNlc0NvbnRlbnQiOlsiPHNjcmlwdD5cbiAgICBleHBvcnQgbGV0IHRleHRcbiAgICBleHBvcnQgbGV0IGhlbHBUZXh0XG4gICAgZXhwb3J0IGxldCBpbWFnZVxuICAgIGV4cG9ydCBsZXQgaWRcbiAgICBleHBvcnQgbGV0IHN0eWxlXG48L3NjcmlwdD5cblxuPGRpdiBpZD17aWR9PlxuPGltZyBjbGFzcz1cInN0ZW5jaWwgXCIgc3JjPXtpbWFnZX0gYWx0PXtoZWxwVGV4dH0gc3R5bGU9e3N0eWxlfS8+XG48ZGl2IGNsYXNzPVwic2xkcy10ZXh0LWhlYWRpbmdfbGFyZ2Ugc2xkcy1hbGlnbl9hYnNvbHV0ZS1jZW50ZXJcIj57dGV4dH08L2Rpdj5cbjwvZGl2PlxuXG48c3R5bGU+XG4gICAgLnN0ZW5jaWwge1xuICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjRDNEQ0U3O1xuICAgICAgICBjb2xvcjogIzU4NzZBMztcbiAgICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICAgICAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gICAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgICBoZWlnaHQ6IGF1dG87XG4gICAgICAgIHRleHQtdHJhbnNmb3JtOiB1cHBlcmNhc2U7XG4gICAgfVxuPC9zdHlsZT5cbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozt3QkFVaUUsR0FBSTs7Ozs7Ozs7Ozs7Ozs7Ozs7d0NBQUosR0FBSTs7Ozs7Ozt5REFEMUMsR0FBSztxQ0FBTyxHQUFRO29DQUFTLEdBQUs7Ozs7K0JBRHBELEdBQUU7Ozs7R0FBWCxvQkFHTTtHQUZOLG9CQUFnRTs7R0FDaEUsb0JBQTRFOzs7O2dGQURqRCxHQUFLOzs7OztzQ0FBTyxHQUFROzs7O3FDQUFTLEdBQUs7OztxREFDSSxHQUFJOzs7Z0NBRjVELEdBQUU7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztPQVBJLElBQUk7T0FDSixRQUFRO09BQ1IsS0FBSztPQUNMLEVBQUU7T0FDRixLQUFLOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OzsifQ==
//# sourceMappingURL=Stencil.js.map
